export const goToPage = (path: string) => {
    window.history.pushState(null, '', path)
}

export const goToPageLogin = () => goToPage('/login')
export const goToPageRegister = () => goToPage('/cadastrar/dados-pessoais')
